// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hideable-paragraph[data-v-098f6b85]{padding:10px 0}.hideable-paragraph .switch[data-v-098f6b85]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hideable-paragraph .switch__header[data-v-098f6b85]{font-size:20px;line-height:26px;font-weight:600}.hideable-paragraph .text[data-v-098f6b85]{white-space:pre-line;word-wrap:break-word;font-size:16px;line-height:22px;font-weight:400;margin-right:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
